export const WIDGET_PAGES = 'widget_pages';
export const WIDGET_PAGE_TEMPLATES = 'widget_page_templates';
export const BADGES = 'badges';
export const BADGES_TEMPLATES = 'badges_templates';
